export default ({ app, $auth }) => {
  $auth.onRedirect(to => app.localePath(to))
}
